import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import PermissionGrid from './PermissionGrid';
import Button from '../../common/components/Button';
import ItemList from '../../common/utils/ItemList';
export default class ExtensionPermissionGrid extends PermissionGrid {
  constructor() {
    super(...arguments);
    _defineProperty(this, "extensionId", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.extensionId = this.attrs.extensionId;
  }
  permissionItems() {
    const items = new ItemList();
    super.permissionItems().toArray().filter(item => item.children.length > 0).forEach(item => {
      items.add(item.itemName, item);
    });
    return items;
  }
  viewItems() {
    return app.registry.getExtensionPermissions(this.extensionId, 'view') || new ItemList();
  }
  startItems() {
    return app.registry.getExtensionPermissions(this.extensionId, 'start') || new ItemList();
  }
  replyItems() {
    return app.registry.getExtensionPermissions(this.extensionId, 'reply') || new ItemList();
  }
  moderateItems() {
    return app.registry.getExtensionPermissions(this.extensionId, 'moderate') || new ItemList();
  }
  scopeControlItems() {
    const items = new ItemList();
    items.add('configureScopes', m(Button, {
      className: "Button Button--text",
      onclick: () => m.route.set(app.route('permissions'))
    }, app.translator.trans('core.admin.extension.configure_scopes')));
    return items;
  }
}
flarum.reg.add('core', 'admin/components/ExtensionPermissionGrid', ExtensionPermissionGrid);